import { ReactElement, useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';

import { APP_ROUTE } from '@backrs_ui/grow-ui/src/appRoutes.constants';
import { useAuth } from '@backrs_ui/grow-ui/src/hooks/useAuth';
import { openSignupPrompt } from '@backrs_ui/grow-ui/src/redux/appState/appState';
import { useAppDispatch } from '@backrs_ui/grow-ui/src/redux/hooks';
import { IS_SANDBOX } from '@backrs_ui/grow-ui/src/utils/sandboxSession';

type ProtectedRouteProps = Readonly<{
  children: ReactElement;
}>;

export const ProtectedRoute = ({ children }: ProtectedRouteProps) => {
  const { loggedIn, isGuest } = useAuth();
  const location = useLocation();
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (isGuest && !loggedIn) {
      dispatch(openSignupPrompt());
    }
  }, [isGuest, loggedIn, dispatch]);

  if (loggedIn) {
    return children;
  }

  // LOGIN is sandbox-blocked, so navigating there is dropped and renders nothing.
  if (isGuest || IS_SANDBOX) {
    return <Navigate to={APP_ROUTE.HOME} replace />;
  }

  // preserve where the user was trying to go so login can redirect them back
  const redirectTo = `${location.pathname}${location.search}${location.hash}`;

  return <Navigate to={APP_ROUTE.LOGIN} replace state={{ from: redirectTo }} />;
};
